module.exports = __webpack_public_path__ + "static/media/turbocharger-mr-card-back.8eeb4579.jpeg";